<template>
  <table @click.stop class="machine-service-timeline table table-settings-service" :class="{'dragging-container': dragging}">
    <tbody>
    <tr>
      <td>
        <small style="color: #719dc6;">План</small>
      </td>
      <td v-for="day in daysComputed" class="circle-td">
        <div
          class="planned mx-auto mb-2"
          :class="markerClass(service, true)"
          v-for="service in day.planned"
          @dragenter="dragenter($event, service)"
          @dragleave="dragleave($event, service)"
          @drop="leave(service)"
          @click="edit(day, service)"
          @dragover.prevent
          :draggable="$root.canCreateService()"
          @dragstart="dragPlanned(service, $event)"
          @dragend="dropPlanned(service)"
        >
          <div v-if="service.circles.tl" class="circle small-circle top-left-circle"></div>
          <div v-if="service.circles.tr" class="circle small-circle top-right-circle" :class="trColor(service.circles.tr)"></div>
          <div v-if="service.circles.bl" class="circle small-circle bottom-left-circle"></div>
          <div v-if="service.circles.br" class="circle small-circle bottom-right-circle"></div>
        </div>
      </td>
    </tr>
    <tr>
      <td></td>
      <td v-for="day in daysComputed"
          @click="create(day)"
          @drop="leavePlanned(day)"
          @dragover.prevent>
        <div  :class="'number-container mx-auto ' + (day.weekday == 0 ? 'sunday' : (day.weekday == 6 ? 'saturday' : ''))">
          <div class="number">{{day.day}}</div>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <small style="color: #5fa615;">Факт</small>
      </td>
      <td v-for="day in daysComputed">
        <div
          v-for="service in day.performed"
          class="mx-auto mb-2"
          :class="markerClass(service, false)"
          :draggable="!service.planned_service_id"
          @dragstart="drag(service, $event)"
          @dragend="drop(service)"
          @click="showPerformed(service)"
        >
          <div v-if="service.circles.tl" class="circle small-circle top-left-circle"></div>
          <div v-if="service.circles.tr" class="circle small-circle top-right-circle" :class="trColor(service.circles.tr)"></div>
          <div v-if="service.circles.bl" class="circle small-circle bottom-left-circle"></div>
          <div v-if="service.circles.br" class="circle small-circle bottom-right-circle"></div>
          <div class="empty"></div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
  import serviceModalPlanned from './service-modal-planned.vue'
  import serviceModalPerformed from './service-modal-performed.vue'
  import moment from 'moment'
  import { each, get } from 'lodash'
  import api from '@/api'

  export default {
    name: 'MachineServiceTimeline',
    props: ['planned_prop', 'performed_prop', 'machine_id', 'operator', 'tech', 'region_id'],
    data () {
      return {
        dragging: false,
        selectedService: null,
        draggingOver: null,
        draggingPlanned: false,
        selectedServicePlanned: null,
      }
    },
    methods: {
      serviceModalPlanned (day, service, func) {
        this.$root.showModal(serviceModalPlanned, {
          machine_id: this.machine_id,
          date: day.fullDate,
          service: service,
          default_operator: this.operator,
          default_tech: this.tech,
          region_id: this.region_id,
        }).then((data) => {
          if (data) {
            if (data.deleted) {
              let index = Array.findIndex(this.planned, (current) => current.id === service.id)
              this.planned.splice(index, 1)
            } else {
              func(data.data)
            }
          }
        })
      },
      showPerformed (current) {
        this.$root.showModal(serviceModalPerformed, {
          executor: current.executor,
          id: current.id,
        })
      },
      edit (day, service) {
        this.serviceModalPlanned(day, service, (data) => {
          let index = Array.findIndex(this.planned, (current) => current.id === service.id)
          Object.assign(this.planned[index], data)
        })
      },
      create (day) {
        if (this.$root.canCreateService() && moment.utc().date() <= day.day) {
          let serviceParam = { done: false, is_recommended: false }
          this.serviceModalPlanned(day, serviceParam, (data) => {
            data.forEach((curr) => {
              this.planned.push(curr)
            })
          })
        }
      },
      drag (service, event) {
        if (this.$root.canCreateService()) {
          if (service.planned_service_id === null) {
            event.dataTransfer.setData('text/plain', '')
            this.dragging = true
            this.selectedService = service
          }
        } else {
          event.preventDefault()
        }
      },
      drop (service) {
        if (service.planned_service_id === null) {
          this.dragging = false
          this.selectedService = null
        }
      },
      dragenter ($e, service) {
        this.draggingOver = service.id
      },
      dragleave ($e, service) {
        this.draggingOver = null
      },
      leave (service) {
        if (this.dragging && this.withoutPerformed(service)) {
          let buf = this.selectedService
          api.post('services/bind', {
            planned_service_id: service.id,
            id: buf.id,
          }).then(() => {
            buf.planned_service_id = service.id
            service.done = true
          })
        }
      },
      dragPlanned (service, event) {
        event.dataTransfer.setData('text/plain', '')
        this.draggingPlanned = true
        this.selectedServicePlanned = service
      },
      dropPlanned (service) {
        this.draggingPlanned = false
        this.selectedServicePlanned = null
      },
      leavePlanned (day) {
        if (this.draggingPlanned && moment.utc().date() <= day.day) {
          let buf = this.selectedServicePlanned
          api.put(`services/planned/${buf.id}`, {
            date: day.fullDate,
          }).then((data) => {
            let index = Array.findIndex(this.planned, (current) => current.id === buf.id)
            Object.assign(this.planned[index], {date: day.fullDate})
          })
        }
      },
      trColor (number) {
        switch (number) {
          case 1: return ''
          case 2: return 'brown'
          case 3: return 'purple'
        }
      },
      withoutPerformed (service) {
        return !service.done && !service.is_recommended && this.selectedService &&
          JSON.stringify(service.circles) === JSON.stringify(this.selectedService.circles) &&
            moment(this.selectedService.date).diff(moment(service.date), 'days') >= 0
      },
      markerClass (service, isPlanned) {
        const classes = []
        if (isPlanned && this.withoutPerformed(service)) {
          classes.push('without-performed')
          if (this.draggingOver === service.id) {
            classes.push('drop-target')
          }
        }
        if (service.circles.triangle) {
          if (isPlanned || service.planned_service_id !== null) {
            classes.push('triangle')
          }
          if (isPlanned) {
            classes.push('triangle-planned')
          } else if (service.late) {
            classes.push('triangle-late')
          } else {
            classes.push('triangle-performed')
          }
        } else {
          if (['service', 'service_superior'].includes(get(service, 'executor.role.name'))) {
            classes.push('circle')
          }
          classes.push('circle-container')

          if (isPlanned) {
            classes.push('bg-primary')
          } else if (service.late) {
            classes.push('bg-danger')
          } else {
            classes.push('green')
          }
        }
        if (!isPlanned && service.planned_service_id === null) {
          if (service.circles.triangle) {
            classes.push('triangle-without-planned')
          } else {
            classes.push('without-planned')
          }
        }
        if (service.is_recommended || service.recommendation) {
          classes.push('has-recommendation')
        }
        return classes
      },
    },
    computed: {
      planned () {
        return this.planned_prop
      },
      performed () {
        return this.performed_prop
      },
      daysComputed () {
        var currentDay = new Date()
        currentDay.setUTCDate(new Date().getUTCDate() - currentDay.getUTCDate() + 1)
        currentDay.setUTCHours(0)
        currentDay.setUTCMinutes(0)
        currentDay.setUTCSeconds(0)
        var days = []
        let data = []
        each(this.planned, (date) => {
          let str = new Date(date.date).toUTCString()
          if (data[str] === undefined) {
            data[str] = {
              performed: [],
              planned: [],
            }
          }
          data[str].planned.push(date)
        })
        each(this.performed, (date) => {
          let str = new Date(date.date)
          str.setUTCHours(0, 0, 0)
          str = str.toUTCString()
          if (data[str] === undefined) {
            data[str] = {
              performed: [],
              planned: [],
            }
          }
          data[str].performed.push(date)
        })
        let d = new Date(Date.UTC(currentDay.getUTCFullYear(), currentDay.getUTCMonth() + 1, 0))
        let monthSize = d.getUTCDate()
        for (var i = 0; i < monthSize; i++) {
          let planned = []
          let performed = []
          if (currentDay.toUTCString() in data) {
            planned = data[currentDay.toUTCString()].planned
            performed = data[currentDay.toUTCString()].performed
          }
          days.push({
            day: currentDay.getUTCDate(),
            planned: planned,
            performed: performed,
            fullDate: moment.utc(currentDay).format('YYYY-MM-DD'),
            weekday: moment.utc(currentDay).day(),
          })
          currentDay.setUTCDate(currentDay.getUTCDate() + 1)
        }

        return days
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .machine-service-timeline {
    margin: 10px 0;
    .number-container {
      cursor: pointer;
      background-color: #b7bcc0;
      color: #ffffff;
      border-radius: 50%;
      text-align: center;
      width: 1.9em;
      height: 1.9em;
      line-height: 1.9;
    }
    .saturday {
      background-color: #979ca0;
    }
    .sunday {
      background-color: #676c70;
    }
    &,
    & tr,
    & td {
      background: transparent !important;
    }
    & td {
      height: auto !important;
      padding: .2rem !important;
      border-width: 0px !important;
    }
    .circle-td {
      vertical-align: bottom !important;
    }
    .circle-container {
      cursor: pointer;
      position: relative;
      width: 18px !important;
      height: 18px !important;
    }
    .circle {
      border-radius: 50%;
    }
    .small-circle {
      width: 7px;
      height: 7px;
      position: absolute;
    }
    .top-left-circle {
      top: -2px;
      left: -2px;
      background-color: black;
    }
    .top-right-circle {
      top: -2px;
      right: -2px;
      background-color: #5fa615;
    }
    .purple {
      background-color: #bd10e0;
    }
    .brown {
      background-color: #8b572a;
    }
    .green{
      background-color: #90d726;
    }
    .bottom-left-circle {
      bottom: -2px;
      left: -2px;
      background-color: #db392a;
    }
    .bottom-right-circle {
      bottom: -2px;
      right: -2px;
      background-color: #f5a623;
    }
    .triangle {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 18px solid #428bca;
    }
    .triangle-planned {
      border-bottom-color: #428bca;
    }
    .triangle-late {
      border-bottom-color: #bf3030;
    }
    .triangle-performed {
      border-bottom-color: #7db22d;
    }
    .triangle-without-planned {
      position: relative;
      width:0;
      border-bottom:solid 18px #537f2d;
      border-right:solid 10px transparent;
      border-left:solid 10px transparent;
    }
    .triangle-without-planned .empty {
      position: absolute;
      top:7px;
      left:-5px;
      width:0;
      border-bottom:solid 8px;
      border-right:solid 5px transparent;
      border-left:solid 5px transparent;
    }
    .triangle-late .empty {
      border-bottom-color: #bf3030;
    }
    .triangle-performed .empty {
      border-bottom-color: #7db22d;
    }
    .without-planned {
      box-shadow: inset 0 0 0 4px rgba($gray-900, 0.5);
    }
    &.dragging-container {
      .planned:not(.without-performed) {
        opacity: 0.33;
      }
      .without-performed {
        box-shadow: 0 0 0 3px #fff, 0 0 0 6px rgba($primary, 0.5);
        &.drop-target {
          box-shadow: 0 0 0 3px #fff, 0 0 0 10px rgba($primary, 0.5);
        }
      }
    }

    body {
      background: #454a59;
    }

    .has-recommendation {
      position: relative;
      transform: translateZ(0.01px);
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 300%;
        height: 300%;
        box-sizing: border-box;
        margin-left: -100%;
        margin-top: -100%;
        border-radius: 50%;
        background-color: #01a4e9;
        animation: pulse-ring 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: 100%;
        height: 100%;
        background-color: white;
        border-radius: 50%;
        animation: pulse-dot 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -.4s infinite;
      }
      @keyframes pulse-ring {
        0% {
          transform: scale(.33);
        }
        80%, 100% {
          opacity: 0;
        }
      }
      @keyframes pulse-dot {
        0% {
          transform: scale(.3);
        }
        40% {
          transform: scale(.6);
        }
        100% {
          transform: scale(.3);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/machine-service-timeline.vue